// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import DataTable from "@insite/mobius/DataTable";
import GridItem from "@insite/mobius/GridItem";
import { DataTableBody, DataTableCell, DataTableHead, DataTableHeader, DataTableRow } from "@insite/mobius/index";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { fixDate } from "@store/Framework/Common/Utilities/reportingUtils";
import { ServiceHistoryInvoiceModel } from "@store/Framework/Services/Reporting/ReportingModels";
import React from "react";
import styled, { css } from "styled-components";

const ModalSubTitle = styled.p`
    && {
        color: white;
        font-size: 0.75rem;
        width: 100%;
        font-weight: 500;
        padding: 0.25rem 1rem;
        background-color: #3d5689;
        border-radius: 0.5rem;
    }
`;

const serviceItemHeaders = ["Serial #", "Make", "Model", "Purchase Date"];
const serviceItemKeys: (keyof ServiceHistoryInvoiceModel)[] = ["serialNumber", "manufacturer", "model", "orderDate"];
const timelineHeaders = ["Order Date", "Invoice Date", "Started Date", "Completed Date"];
const timelineHeadersKeys: (keyof ServiceHistoryInvoiceModel)[] = [
    "orderDate",
    "invoiceDate",
    "startedDate",
    "completedDate",
];

interface Props {
    serviceHistoryInvoice: ServiceHistoryInvoiceModel;
}
const ServiceHistorySubHeaders: React.FC<Props> = ({ serviceHistoryInvoice }) => {
    return (
        <GridItem
            css={css`
                display: flex;
                gap: 1rem;
                justify-content: space-between;
                align-items: baseline;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: row;
                        `,
                        css`
                            flex-direction: row;
                        `,
                    ]);
                }}
            `}
            width={[12, 12, 12, 12, 12]}
        >
            <GridItem
                css={css`
                    flex-direction: column;
                `}
                width={[12, 12, 12, 6, 6]}
            >
                <ModalSubTitle>{translate("TIMELINE")}</ModalSubTitle>
                <DataTable>
                    <DataTableHead>
                        {timelineHeaders.map(header => (
                            <DataTableHeader key={header}>{header}</DataTableHeader>
                        ))}
                    </DataTableHead>
                    <DataTableBody>
                        <DataTableRow>
                            {timelineHeadersKeys.map(key => (
                                <DataTableCell key={key}>
                                    {fixDate(serviceHistoryInvoice[key] as string | number)}
                                </DataTableCell>
                            ))}
                        </DataTableRow>
                    </DataTableBody>
                </DataTable>
            </GridItem>
            <GridItem
                css={css`
                    flex-direction: column;
                `}
                width={[12, 12, 12, 6, 6]}
            >
                <ModalSubTitle>{translate("SERVICE ITEM")}</ModalSubTitle>
                <DataTable>
                    <DataTableHead>
                        {serviceItemHeaders.map(header => (
                            <DataTableHeader key={header}>{header}</DataTableHeader>
                        ))}
                    </DataTableHead>
                    <DataTableBody>
                        <DataTableRow>
                            {serviceItemKeys.map(key => (
                                <DataTableCell key={key}>
                                    {fixDate(serviceHistoryInvoice[key] as string | number)}
                                </DataTableCell>
                            ))}
                        </DataTableRow>
                    </DataTableBody>
                </DataTable>
            </GridItem>
        </GridItem>
    );
};

export default ServiceHistorySubHeaders;
